import { isCatalogMarketType, isDefaultMarketType } from './useBuyerMarketType';
import useBuyersProfile from './useBuyersProfile';
import useUser from './useUser';

const useMarketAndCatalogRoutes = () => {
  const buyersProfile = useBuyersProfile();
  const { isAdmin } = useUser();

  if (isAdmin) {
    return {
      showCatalogRoute: true,
      showMarketRoute: true,
    };
  }

  return {
    showCatalogRoute: isCatalogMarketType(buyersProfile?.marketType),
    showMarketRoute: isDefaultMarketType(buyersProfile?.marketType),
  };
};

export default useMarketAndCatalogRoutes;
